<script>
    import { fade } from 'svelte/transition';
    export let menu_open = false;
    import { logout } from '../service/PersistStore.js';
    
</script>

<div class="float-menu-wrapper">
    <button class="float-menu-btn" on:click="{ () => { menu_open = true } }">
        <div class="rpgui-icon potion-blue"></div>
    </button>
    {#if menu_open }
    <div class="float-menu" in:fade="{{ duration: 250 }}" out:fade="{{ duration: 50 }}">
        <div class="float-menu__cotent">
            <button class="float-menu__close" on:click="{ () => { menu_open = false } }">
                X
            </button>
            <div class="float-menu__list">
                <slot></slot>
                <div class="float-menu__list-item" on:click="{ () => logout() }"> > Logout</div>
                <div class="float-menu__list-item" style="display: none;"></div>
            </div>
        </div>
    </div>
    {/if}
</div>